/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {},
  ERROR: {
    FETCH_ATTACHMENTS: 'Ottenere allegati'
  },
  HEADER: {
    DATE: 'Data',
    SENT_BY_F: 'Inviato da',
    TITLE: 'Titolo'
  },
  LABEL: {
    ATTACHMENTS: 'Allegati',
    DATE: 'Data',
    DETAIL: 'Dettaglio',
    MESSAGE: 'Messaggio',
    NO_ROWS_COMMUNICATIONS: 'Nessuna comunicazione',
    SENT_BY_F: 'Inviato da',
    TITLE: 'Titolo',
    UNREAD: 'Non letto'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
